import vision from "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.3";

( function initFaceScanPopup () {
  const { FaceLandmarker, FilesetResolver } = vision;

  const config = JSON.parse(document.querySelector( "#FaceScanConfig" ).innerText);
  const faceScanContainer = document.querySelector( ".face-scan-container" );
  const faceWidthCheckbox = document.querySelector( "#FaceWidthCheckbox" );
  const showBtns = document.querySelectorAll( '[data-popup="face-scan-app"]' );
  const introBtn = document.querySelector("#IntroContinue")
  const instructionBtn = document.querySelector("#InstructionsContinue")
  const chooseBtns = document.querySelectorAll("[data-choose-button]")
  const camReadyBtn = document.querySelector( "#FaceScanCamReady" );
  const videoReadyBtn = document.querySelector( "#FaceScanVideoReady" );
  const confirmBtn = document.querySelector( "#FaceScanConfirm" );
  // const repeatBtn = document.querySelector( "#FaceScanRepeat" );
  const popup = document.querySelector(
    ".popup--face-scan-app [data-curr-step]"
  );
  const closeBtn = document.querySelector(
    ".popup--face-scan-app .popup__close"
  );
  const videoMessage = popup.querySelector( ".face-scan-message" );
  const instructionsBtn = popup.querySelector( "#FaceScanVideoInfoToggle" );
  const optionRadios = [...document.querySelectorAll( `.product-single__form .group--fciv .item__radio` )]

  const WASM_URL =
    "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.3/wasm";
  const MODEL_URL =
    "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task";

  const LEFT_IRIS_LEFT = 474
  const LEFT_IRIS_RIGHT = 476;
  const RIGHT_IRIS_LEFT = 469
  const RIGHT_IRIS_RIGHT = 471;
  const LEFT_CHEEK_INDEX = 127
  const RIGHT_CHEEK_INDEX = 356;
  const REAL_IRIS_DIAMETER_CM = 1.2;
  const LEFT_IRIS_CENTER = 468;
  const RIGHT_IRIS_CENTER = 473;

  const EYES_OVAL_PERC_MIN = 35;
  const EYES_OVAL_PERC_MAX = 38;

  const MAX_HOLD_MS = 5 * 1000
  const MAX_GRACE_MS = 0.5 * 1000

  let camStream;
  let faceLandmarker;
  let faceWidthCm;
  let holdStartTime = null
  let lastHoldTime = null
  let prevHoldMs = 0
  let currHoldMs = 0
  let faceWidths = new Map()
  let predictWebcamFrameId = null;

  const isMobile = window.matchMedia( "(max-width: 767px)" ).matches;
  const videoElement = document.createElement( "video" );
  videoElement.autoplay = true;
  videoElement.playsInline = true;

  const camConstraints = {
    video: {
      width: isMobile ? 480 : 640,
      height: isMobile ? 640 : 480,
      facingMode: "user",
    },
  };
  const canvasElement = document.querySelector( "#face-scan-canvas" );
  const canvasCtx = canvasElement.getContext( "2d" );

  showBtns.forEach(b => b.addEventListener( "click", showPopup ));
  introBtn.addEventListener( "click", confirmIntro );
  instructionBtn.addEventListener( "click", confirmInstructions );
  chooseBtns.forEach(b => b.addEventListener( "click", chooseSize ));
  camReadyBtn.addEventListener( "click", requestCamAccess );
  document.body.addEventListener( `popupClose:face-scan-app`, onClose );
  instructionsBtn.addEventListener( "click", toggleInstructions );
  confirmBtn.addEventListener( "click", confirmResult );
  // repeatBtn.addEventListener( "click", repeatMeasurement );

  if ( new URLSearchParams( location.search ).has( "test_id" ) ) {
    localStorage.setItem( "face_app_test_id", new URLSearchParams( location.search ).get( "test_id" ) )
  }
 
  function stopCameraStream () {
    if ( camStream && camStream.getTracks ) {
      camStream.getTracks().forEach( track => track.stop() );
      camStream = null;
    }
    if ( videoElement.srcObject ) {
      videoElement.srcObject = null;
    }
    // Remove all event listeners from videoElement by replacing it
    const newVideo = videoElement.cloneNode( true );
    videoElement.parentNode && videoElement.parentNode.replaceChild( newVideo, videoElement );
    // Re-assign videoElement reference
    // Note: This only works if videoElement is attached to DOM, otherwise skip
    // If not attached, just remove all listeners below
  }

  function onClose () {
    // Stop camera stream and remove video event listeners
    stopCameraStream();
    videoElement.removeEventListener( "loadeddata", predictWebcam );

    // Cancel animation frame
    if ( predictWebcamFrameId !== null ) {
      cancelAnimationFrame( predictWebcamFrameId );
      predictWebcamFrameId = null;
    }

    // Clear canvas
    canvasCtx.clearRect( 0, 0, canvasElement.width, canvasElement.height );

    // Reset state variables
    resetMeasureState()
    faceLandmarker = undefined;
    // Optionally reset UI
    videoMessage.innerHTML = "";
    videoMessage.classList.remove( "face-scan-error", "face-scan-success" );
    // Reset popup step if needed
    popup.setAttribute( "data-curr-step", "intro" );
    // popup.removeAttribute( "data-curr-step" );
  }

  function showPopup() {
    popup.dataset.currStep = "intro";
  }
  
  function confirmIntro() {
    popup.dataset.currStep = "instructions";
  }
  
  function confirmInstructions() {
    popup.dataset.currStep = "choose";
  }

  function chooseSize(e) {
    const choice = e.currentTarget.dataset.choice
    popup.dataset.choice = choice
    popup.dataset.currStep = "camera"
    checkCameraAccessAndStart()
  }

  async function checkCameraAccessAndStart () {
    try {
      const status = await navigator.permissions.query( { name: "camera" } );
      if ( status.state === "granted" ) {
        showVideoScreen();
      } else if ( status.state === "denied" ) {
        popup
          .querySelector( ".face-scan-error" )
          .classList.add( "face-scan-error-shown" );
      }
    } catch ( error ) {
      console.error( error );
    }
  }

  async function requestCamAccess () {
    try {
      const result = await navigator.mediaDevices.getUserMedia( camConstraints );
      camStream = result;

      showVideoScreen();
    } catch ( error ) {
      console.error( error );

      popup
        .querySelector( ".face-scan-error" )
        .classList.add( "face-scan-error-shown" );
      return;
    }
  }

  function showCameraScreen () {
    popup.dataset.currStep = "camera";
  }

  function showVideoScreen () {
    popup.dataset.currStep = "video";
    initScanning();
  }

  function approveResult () {
    const avgFaceWidth = [ ...faceWidths.values() ].reduce( ( v, acc ) => acc + v, 0 ) / faceWidths.size;
    const widthMm = Math.round(avgFaceWidth * 10)
    // document.querySelector("#FaceScanResultNum").innerText = `${widthMm}mm`;
    popup.dataset.measuredResult = widthMm;
    popup.setAttribute( "data-curr-step", "confirm" );
    stopCameraStream()
  }

  function calcWithFormula(measuredMm, choiceRangeTo) {
    const cache = new Map()

    const key = `${measuredMm}_${choiceRangeTo}`

    const existing = cache.get(key)

    if (existing) {
      return existing;
    }

    const variables = {
      measured_mm: measuredMm,
      choice_range_to: choiceRangeTo 
    }

    let expr = config.formula;
    Object.entries(variables).forEach(([k, v]) => {
      expr = expr.replace(new RegExp(`\\b${k}\\b`, "g"), v);
    });

    const weighted = Math.round(evaluateFormula(expr));

    cache.set(key, weighted)

    return weighted
  }
  
  function confirmResult() {
    const choice = popup.dataset.choice // narrow | normal | wide
    const measuredMm = Number(popup.dataset.measuredResult)

    const choiceRangeTo = config.rangesTo.find(r => r.choiceName === choice).mm

    const weighted = calcWithFormula(measuredMm, choiceRangeTo)

    let finalSize
    for (const r of config.rangesTo) {
      finalSize = r.name
      if (weighted <= r.mm) {
        break
      }
    }

    const radio = optionRadios.find(r => r.value === finalSize)?.click()

    // const radio = optionRadios.find(r => r.value === finalSize)
    // radio.checked = true
    // radio.dispatchEvent(new Event("change", { bubbles: true }))

    faceWidthCheckbox.classList.add("measured")
    faceScanContainer.classList.add("measured")

    popup.removeAttribute("data-measured-result")
    popup.removeAttribute("data-choice")
    popup.removeAttribute( "data-curr-step" );
    closeBtn.click();

    const productForm = faceWidthCheckbox.closest(".product-single__form")
    
    let choiceHiddenInput = productForm.querySelector("[name='properties[_choice]']")
    if (!choiceHiddenInput) {
      choiceHiddenInput = document.createElement("input")
      choiceHiddenInput.type = "hidden"
      choiceHiddenInput.name = "properties[_choice]"
      productForm.appendChild(choiceHiddenInput)
    }
    choiceHiddenInput.value = choice
    
    let measuredHiddenInput = productForm.querySelector("[name='properties[_measured_mm]']")
    if (!measuredHiddenInput) {
      measuredHiddenInput = document.createElement("input")
      measuredHiddenInput.type = "hidden"
      measuredHiddenInput.name = "properties[_measured_mm]"
      productForm.appendChild(measuredHiddenInput)
    }
    measuredHiddenInput.value = measuredMm
  }
  
  // function repeatMeasurement() {
  //   initScanning();
  //   popup.removeAttribute("data-measured-result")
  //   popup.removeAttribute("data-choice")
  //   popup.setAttribute( "data-curr-step", "video" );

  // }

  function toggleInstructions () {
    document.querySelector( ".face-scan-video-info" ).classList.toggle( "instructions-shown" )
  }

  async function initScanning () {
    if ( !camStream ) {
      try {
        const result = await navigator.mediaDevices.getUserMedia( camConstraints );
        if ( !result ) {
          showCameraScreen();
          return;
        }
        camStream = result;
      } catch ( error ) {
        console.error( error );
        alert( "ERROR" );
      }
    }

    const filesetResolver = await FilesetResolver.forVisionTasks( WASM_URL );
    faceLandmarker = await FaceLandmarker.createFromOptions( filesetResolver, {
      baseOptions: {
        modelAssetPath: MODEL_URL,
        delegate: "GPU",
      },
      runningMode: "VIDEO",
      numFaces: 1,
    } );

    videoElement.srcObject = camStream;
    // Remove any previous event listener to avoid duplicates
    videoElement.removeEventListener( "loadeddata", predictWebcam );
    videoElement.addEventListener( "loadeddata", predictWebcam );

    popup
      .querySelector( ".face-scan-video-loader" )
      .classList.remove( "video-loading" );
  }

  async function predictWebcam () {
    try {
      if ( videoElement.videoWidth <= 0 || videoElement.videoHeight <= 0 ) {
        predictWebcamFrameId = requestAnimationFrame( predictWebcam );
        resetMeasureState()
        return;
      }

      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;

      const results = faceLandmarker.detectForVideo(
        videoElement,
        performance.now()
      );

      // Clear and draw mirrored video
      canvasCtx.clearRect( 0, 0, canvasElement.width, canvasElement.height );
      canvasCtx.save();
      canvasCtx.translate( canvasElement.width, 0 );
      canvasCtx.scale( -1, 1 );
      canvasCtx.drawImage(
        videoElement,
        0,
        0,
        canvasElement.width,
        canvasElement.height
      );
      canvasCtx.restore();

      drawFrameOutline();


      if ( !results?.faceLandmarks?.length ) {
        updateMessage( { isFaceShown: false } );
        if (Date.now() - lastHoldTime > MAX_GRACE_MS) {
          resetMeasureState()
        } else {
          prevHoldMs += currHoldMs
          currHoldMs = 0
          holdStartTime = null
        }
        predictWebcamFrameId = window.requestAnimationFrame( predictWebcam );
        return;
      }

      // Flip X for overlays to match mirrored video
      const landmarks = results.faceLandmarks[ 0 ].map( pt => ( {
        ...pt,
        x: 1 - pt.x
      } ) );

      drawFaceOutline( landmarks );

      drawEarDots( landmarks )

      const { isPositionCorrect, isDistanceCorrect, distancePercent } = assessFacePositionAndDistance( landmarks )

      updateMessage( {
        isPositionCorrect,
        isDistanceCorrect,
        isFaceShown: true,
        distancePercent
      } )

      if ( !isPositionCorrect || !isDistanceCorrect ) {
        predictWebcamFrameId = requestAnimationFrame( predictWebcam );
        if (Date.now() - lastHoldTime > MAX_GRACE_MS) {
          resetMeasureState()
        } else {
          prevHoldMs += currHoldMs
          currHoldMs = 0
          holdStartTime = null
        }
        return;
      }

      const leftIrisPx = Math.abs( landmarks[ LEFT_IRIS_RIGHT ].x - landmarks[ LEFT_IRIS_LEFT ].x ) * canvasElement.width;
      const rightIrisPx = Math.abs( landmarks[ RIGHT_IRIS_RIGHT ].x - landmarks[ RIGHT_IRIS_LEFT ].x ) * canvasElement.width;
      const avgIrisPx = ( leftIrisPx + rightIrisPx ) / 2;

      const pxL = { x: landmarks[ LEFT_CHEEK_INDEX ].x * canvasElement.width, y: landmarks[ LEFT_CHEEK_INDEX ].y * canvasElement.height };
      const pxR = { x: landmarks[ RIGHT_CHEEK_INDEX ].x * canvasElement.width, y: landmarks[ RIGHT_CHEEK_INDEX ].y * canvasElement.height };
      const faceWidthPx = Math.hypot( pxR.x - pxL.x, pxR.y - pxL.y );

      const pxPerCm = avgIrisPx / REAL_IRIS_DIAMETER_CM;
      faceWidthCm = faceWidthPx / pxPerCm;


      const now = Date.now()

      if ( !holdStartTime ) {
        holdStartTime = now;
      }
      lastHoldTime = now

      const msPassed = now - holdStartTime
      currHoldMs = msPassed
      const secondsPassed = Math.floor( currHoldMs / 1000 );
      if ( !faceWidths.has( secondsPassed ) ) {
        faceWidths.set( secondsPassed, faceWidthCm );
      }

      updateMessage( {
        isPositionCorrect: true,
        isDistanceCorrect,
        isFaceShown: true,
        // secondsRemaining: Math.max( 1, 5 - secondsPassed ),
        secondsRemaining: Math.max(0, Math.floor( (MAX_HOLD_MS - (currHoldMs + prevHoldMs)) / 1000 )),
        distancePercent
      } )

      if ( currHoldMs + prevHoldMs >= MAX_HOLD_MS ) {
      // if ( secondsPassed > 5 ) {
        approveResult()
        resetMeasureState()
      }
    } catch ( error ) {
      console.error( error );
      resetMeasureState()
      updateMessage( {
        isFaceShown: false,
      } )
    }

    predictWebcamFrameId = window.requestAnimationFrame( predictWebcam );
  }

  function resetMeasureState () {
    faceWidthCm = undefined;
    holdStartTime = null;
    lastHoldTime = null;
    prevHoldMs = 0
    currHoldMs = 0
    faceWidths.clear()
  }

  function updateMessage ( { isFaceShown, isPositionCorrect, isDistanceCorrect, distancePercent, secondsRemaining } ) {
    if ( !isFaceShown ) {
      if ( videoMessage.children[ 0 ]?.dataset.isFaceShownError ) {
        return
      }
      videoMessage.innerHTML =
        `<div data-is-face-shown-error='true'>${ window.Shopify?.FaceScan?.translations?.faceNotDetected || "Face not detected in the frame." }</div>`;
      videoMessage.classList.add( "face-scan-error" );
      videoMessage.classList.remove( "face-scan-success" );
      videoMessage.classList.remove( "face-scan-error--warning" );
      return;
    }
    if ( !isPositionCorrect ) {
      if ( videoMessage.children[ 0 ]?.dataset.isFacePositionError ) {
        return
      }
      videoMessage.innerHTML = `<div data-is-face-position-error="true">${ window.Shopify?.FaceScan?.translations?.placeFaceInFrame || "Place your face within the frame." }</div>`;
      videoMessage.classList.add( "face-scan-error" );
      videoMessage.classList.remove( "face-scan-error--warning" );
      videoMessage.classList.remove( "face-scan-success" );
      return
    }
    if ( !isDistanceCorrect ) {
      if ( videoMessage.children[ 0 ]?.dataset.isFaceDistanceError ) {
        return
      }
      videoMessage.innerHTML = `<div data-is-face-distance-error="true">${ 
        distancePercent >= EYES_OVAL_PERC_MIN 
        ? (window.Shopify?.FaceScan?.translations?.moveFurtherAway || "Move further away from the camera.") 
        : window.Shopify?.FaceScan?.translations?.moveCloser || "Move closer to the camera."
        }</div>`;
      videoMessage.classList.add( "face-scan-error" );
      videoMessage.classList.add( "face-scan-error--warning" );
      videoMessage.classList.remove( "face-scan-success" );

      return
    }

    if ( !faceWidthCm ) {
      return
    }

    if ( videoMessage.dataset.seconds === String( secondsRemaining ) ) {
      return
    }
    const choice = popup.dataset.choice
    const choiceRangeTo = config.rangesTo.find(r => r.choiceName === choice).mm
    const weighted = calcWithFormula(faceWidthCm * 10, choiceRangeTo)

    const holdText = window.Shopify?.FaceScan?.translations?.holdForSecondsHtml
      ? window.Shopify?.FaceScan?.translations?.holdForSecondsHtml
        .replace("{{ ", "")
        .replace(" }}", "")
        .replace("{{seconds}}", secondsRemaining)
      : `Good! Hold for<strong>${ secondsRemaining }</strong>seconds`
    videoMessage.innerHTML = `<div data-seconds="${ secondsRemaining }"><div>${ holdText }</div><div>${ (weighted / 10).toFixed( 1 ) } cm</div></div>`;
    videoMessage.classList.add( "face-scan-success" );
    videoMessage.classList.remove( "face-scan-error" );
  }

  function drawFaceOutline ( landmarks ) {
    if ( !landmarks || landmarks.length === 0 ) return;

    const faceOutlineIndices = [
      10, 338, 297, 332, 284, 251, 389, 356, 454, 323, 361, 288, 397, 365, 379,
      378, 400, 377, 152, 148, 176, 149, 150, 136, 172, 58, 132, 93, 234, 127,
      162, 21, 54, 103, 67, 109, 10,
    ];

    canvasCtx.beginPath();

    let minX = Infinity,
      maxX = -Infinity;
    landmarks.forEach( ( point ) => {
      const x = point.x * canvasElement.width;
      if ( x < minX ) minX = x;
      if ( x > maxX ) maxX = x;
    } );

    const gradient = canvasCtx.createLinearGradient( minX, 0, maxX, 0 );
    gradient.addColorStop( 0, "#e1a4e6" );
    gradient.addColorStop( 0.5078, "#249dfd" );
    gradient.addColorStop( 1, "#a7ef50" );

    canvasCtx.strokeStyle = gradient;

    canvasCtx.lineWidth = 2;

    const start = landmarks[ faceOutlineIndices[ 0 ] ];
    canvasCtx.moveTo(
      start.x * canvasElement.width,
      start.y * canvasElement.height
    );

    faceOutlineIndices.forEach( ( index ) => {
      const point = landmarks[ index ];
      canvasCtx.lineTo(
        point.x * canvasElement.width,
        point.y * canvasElement.height
      );
    } );

    canvasCtx.closePath();
    canvasCtx.stroke();
  }

  function drawFrameOutline () {
    // Draw static oval overlay (centered, vertical, stroke only)
    const ovalHeight = canvasElement.height * 0.65
    const ovalWidth = canvasElement.height * 0.45
    const ovalX = canvasElement.width / 2
    const ovalY = canvasElement.height / 2
    canvasCtx.save()
    canvasCtx.lineWidth = 1
    canvasCtx.strokeStyle = '#fff'
    canvasCtx.beginPath()
    canvasCtx.ellipse(
      ovalX,
      ovalY,
      ovalWidth / 2,
      ovalHeight / 2,
      0,
      0,
      2 * Math.PI
    )
    canvasCtx.stroke()
    canvasCtx.restore()
  }

  function drawEarDots ( landmarks ) {
    if ( !landmarks || landmarks.length === 0 ) return;

    const leftCheek = landmarks[ LEFT_CHEEK_INDEX ];
    const rightCheek = landmarks[ RIGHT_CHEEK_INDEX ];

     const points = [leftCheek, rightCheek];

  points.forEach(pt => {
    const x = pt.x * canvasElement.width;
    const y = pt.y * canvasElement.height;

    // White border
    canvasCtx.beginPath();
    canvasCtx.arc(x, y, 8, 0, 2 * Math.PI);
    canvasCtx.fillStyle = "#fff";
    canvasCtx.fill();

    // Green fill inside
    canvasCtx.beginPath();
    canvasCtx.arc(x, y, 5, 0, 2 * Math.PI);
    canvasCtx.fillStyle = "#4CAF50";
    canvasCtx.fill();
  });
  }



  function assessFacePositionAndDistance ( landmarks ) {
    if ( !landmarks || !landmarks.length ) return false;

    const leftEye = landmarks[ LEFT_IRIS_CENTER ];
    const rightEye = landmarks[ RIGHT_IRIS_CENTER ];

    // Match drawFrameOutline()
    const ovalHeight = canvasElement.height * 0.65;
    const ovalWidth = canvasElement.height * 0.45;
    const cx = canvasElement.width / 2;
    const cy = canvasElement.height / 2;
    const rx = ovalWidth / 2;
    const ry = ovalHeight / 2;

    const toPx = ( p ) => ( {
      x: p.x * canvasElement.width,
      y: p.y * canvasElement.height,
    } );

    const insideEllipse = ( p ) => {
      const dx = p.x - cx;
      const dy = p.y - cy;
      return ( dx * dx ) / ( rx * rx ) + ( dy * dy ) / ( ry * ry ) <= 1;
    };

    const leftPx = toPx( leftEye );
    const rightPx = toPx( rightEye );

    const anyOutside = !insideEllipse( leftPx ) || !insideEllipse( rightPx );

    // Horizontal eye distance vs oval width
    const eyeDistPx = Math.abs( rightEye.x - leftEye.x ) * canvasElement.width;
    const pct = Math.max( 0, Math.min( 100, ( eyeDistPx / ovalWidth ) * 100 ) );

    return {
      isPositionCorrect: !anyOutside,
      isDistanceCorrect: pct >= EYES_OVAL_PERC_MIN && pct <= EYES_OVAL_PERC_MAX,
      distancePercent: pct
    }
  }

  function evaluateFormula(expr) {
    const tokens = expr.match(/\d+(?:\.\d+)?|[()+\-*/]/g);
    const prec = { "+": 1, "-": 1, "*": 2, "/": 2 };
    const output = [];
    const ops = [];

    for (const t of tokens) {
      if (!isNaN(t)) {
        output.push(+t);
      } else if (t in prec) {
        while (ops.length && prec[ops.at(-1)] >= prec[t]) {
          output.push(ops.pop());
        }
        ops.push(t);
      } else if (t === "(") {
        ops.push(t);
      } else if (t === ")") {
        while (ops.at(-1) !== "(") output.push(ops.pop());
        ops.pop();
      }
    }
    while (ops.length) output.push(ops.pop());

    const stack = [];
    for (const t of output) {
      if (typeof t === "number") stack.push(t);
      else {
        const b = stack.pop();
        const a = stack.pop();
        stack.push(
          t === "+" ? a + b :
          t === "-" ? a - b :
          t === "*" ? a * b :
                      a / b
        );
      }
    }
    return stack[0];
  }

  
  if (!window.Shopify) {
    window.Shopify = {}
  }
  if (!window.Shopify.FaceScan) {
    window.Shopify.FaceScan = {}
  }
  window.Shopify.FaceScan.handleAtc = function handleAtc(_triggerEl) {
    const hasMeasured = faceWidthCheckbox.classList.contains("measured")
    const measureWrapper = document.querySelector(".face-scan-controls")
    const isAnimating = measureWrapper.classList.contains("face-scan-erroring")

    if (!hasMeasured) {
      if (isAnimating) {
        return false;
      }

      // if (triggerEl) {
      //   triggerEl.classList.add("trigger-face-scan-erroring")
      
      // }
      measureWrapper.scrollIntoView({behavior: "smooth", block: "nearest" });

      measureWrapper.classList.add("face-scan-erroring")
      
      // setTimeout(() => {
      //   measureWrapper.classList.remove('face-scan-erroring');
      //   void measureWrapper.offsetWidth; // Resets animation
      //   measureWrapper.classList.add('face-scan-erroring');
      // }, 200);
      
      setTimeout(() => {
        measureWrapper.classList.remove('face-scan-erroring');
        // if (triggerEl) {
        //   triggerEl.classList.remove("trigger-face-scan-erroring")
        // }
      }, 1600);
  
      return false;
    }

    const properties = {
      "_choice": document.querySelector("[name='properties[_choice]']").value,
      "_measured_mm": document.querySelector("[name='properties[_measured_mm]']").value
    }
    
    return {properties}
  }

} )();

$(".product-section").on('variantChange', function handleVariantChange(e) {
  const isAvailable = e.variant.available 
  const btn = document.querySelector(".face-scan__measure-btn")
  const input = document.querySelector(".face-width-controls")
  if (isAvailable) {
    btn.removeAttribute("disabled")
    input.classList.remove("disabled")
  } else {
    btn.setAttribute("disabled", "disabled")
    input.classList.add("disabled")
  }
})

